const Sidenavbar = () => {
	return (
		<>
			<div
				className="col-3 admin"
				style={{
					backgroundColor: "#F7F4F4",
					paddingTop: "20px",
				}}>
				<ul>
					<li>
						<a href="/usermanagement">
							<span className="admin-text">
								<i
									style={{ color: "#2d947a", marginRight: "8px" }}
									className="fa fa-user"></i>
								User Management
							</span>
						</a>
					</li>
					<hr />

					<li>
						<a href="/instructorledmanagement">
							<span className="admin-text">
								<i
									style={{ color: "#2d947a", marginRight: "8px" }}
									className="fa fa-graduation-cap"></i>
								Instructor Management
							</span>
						</a>
					</li>
					<hr />

					<li>
						<a href="/coursemanagement">
							<span className="admin-text">
								<i
									style={{ color: "#2d947a", marginRight: "8px" }}
									className="fa fa-book"></i>
								Course Management
							</span>
						</a>
					</li>
					<hr />

					<li>
						<a href="/coursecategorymanangement">
							<span className="admin-text">
								<i
									style={{ color: "#2d947a", marginRight: "8px" }}
									className="fa fa-th-large"></i>
								Course Category Management
							</span>
						</a>
					</li>
					<hr />

					<li>
						<a href="/digitallibrarymanagement">
							<span className="admin-text">
								<i
									style={{ color: "#2d947a", marginRight: "8px" }}
									className="fa fa-file-text"></i>
								Digital Library Management
							</span>
						</a>
					</li>
					<hr />

					<li>
						<a href="/skilldevelopmentmanagement">
							<span className="admin-text">
								<i
									style={{ color: "#2d947a", marginRight: "8px" }}
									className="fa fa-lightbulb-o"></i>
								Skill Development Management
							</span>
						</a>
					</li>
					<hr />

					{/* <li>
						<a href="/groupmanagement">
							<span className="admin-text">
								<i
									style={{ color: "#2d947a", marginRight: "8px" }}
									className="fa fa-users"></i>
								Group Management
							</span>
						</a>
					</li>
					<hr /> */}

					<li>
						<a href="/regulatorycompliencesmanagement">
							<span className="admin-text">
								<i
									style={{ color: "#2d947a", marginRight: "8px" }}
									className="fa fa-balance-scale"></i>
								Regulatory Compliances Management
							</span>
						</a>
					</li>
					<hr />

					<li>
						<a href="/placementmanagement">
							<span className="admin-text">
								<i
									style={{ color: "#2d947a", marginRight: "8px" }}
									className="fa fa-briefcase"></i>
								Placements Management
							</span>
						</a>
					</li>
					<hr />

					<li>
						<a href="/classroommanagement">
							<span className="admin-text">
								<i
									style={{ color: "#2d947a", marginRight: "8px" }}
									className="fa fa-university"></i>
								Class Room Management
							</span>
						</a>
					</li>
					<hr />

					<li>
						<a href="/contactusmanagement">
							<span className="admin-text">
								<i
									style={{ color: "#2d947a", marginRight: "8px" }}
									className="fa fa-envelope"></i>
								Contact Us Management
							</span>
						</a>
					</li>
				</ul>
			</div>
		</>
	);
};
export default Sidenavbar;
